// version.ts
export async function checkVersion(): Promise<boolean> {
  try {
    const res = await fetch("/version.json", { cache: "no-store" });
    const data = await res.json();

    // Prefer a build-time env var. CRA needs REACT_APP_*, Vite uses import.meta.env.*
    const current =
      process.env.REACT_APP_VERSION ??
      process.env.VERSION ??
      // (import.meta as any)?.env?.VITE_APP_VERSION ??
      // (import.meta as any)?.env?.VITE_APP_VERSION ?? //commented on 11/20/2025 by AM after the error // Uncaught SyntaxError: Cannot use 'import.meta' outside a module (at main.787cc2d2.js:2:1522547)
      "";

    const isNew = String(data.version) !== String(current);
    console.log("version check:", String(data.version), String(current), isNew);
    return isNew;
  } catch (err) {
    console.error("Failed to check version:", err);
    return false;
  }
}
